import { render, staticRenderFns } from "./MspForsageOperator.vue?vue&type=template&id=640ce8f9&scoped=true"
import script from "./MspForsageOperator.vue?vue&type=script&lang=js"
export * from "./MspForsageOperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ce8f9",
  null
  
)

export default component.exports